// src/utility/roleRedirect.js
import { Navigate } from "react-router-dom";

/**
 * Role-based redirect mapping
 * Returns the appropriate redirect path based on user role
 */
export const getRedirectPathByRole = (role) => {
  const roleMap = {
    
    'super_admin': '/rmrdc/Dashboard',
    'supplier': '/supplier/dashboard',
    'buyer': '/buyer/dashboard',
  };
  
  const normalizedRole = role?.toLowerCase?.() || '';
  const path = roleMap[normalizedRole];
  
  if (!path) {
    console.warn(`[RoleRedirect] Unknown role: "${role}", defaulting to /dashboard`);
    return '/dashboard';
  }
  
  return path;
};

/**
 * ProtectedRoute component to check authentication & role
 */
export const ProtectedRoute = ({ children, allowedRoles }) => {
  const authToken = localStorage.getItem("access_token");
  const userRole = localStorage.getItem("user_role");
  const userData = localStorage.getItem("user_data");
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const isActive = localStorage.getItem("is_active") === 'true';
  const isVerified = localStorage.getItem("is_verified") === 'true';
  const businessVerified = localStorage.getItem("business_verified") === 'true';

  console.log("[ProtectedRoute] Auth Check:", {
    hasToken: !!authToken,
    hasUserData: !!userData,
    userId,
    userType,
    isActive,
    isVerified,
    businessVerified,
    allowedRoles
  });

  if (!authToken || !userId || !userData) {
    console.warn("[ProtectedRoute] Not authenticated - redirecting to login");
    return <Navigate to="/" replace />;
  }

  if (!isActive) {
    console.warn("[ProtectedRoute] Account is inactive - redirecting to login");
    return <Navigate to="/" replace />;
  }

  if (!isVerified) {
    console.warn("[ProtectedRoute] Email not verified - redirecting to login");
    return <Navigate to="/" replace />;
  }

  if (userType === 'supplier' && !businessVerified) {
    console.warn("[ProtectedRoute] Business not verified - redirecting to login");
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(userRole)) {
      console.warn("[ProtectedRoute] Role not allowed - redirecting to login", { 
        userRole, 
        allowedRoles 
      });
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

// Default export for convenience
export default getRedirectPathByRole;